import React from "react";

import { useContext } from "react";
import { AppContext } from "components/app/RemExprertProvider";
import RevenusRetraiteCell from "./RevenusRetraiteCell";
import CardBox from "components/ui/controls/card-box/card-box";
import Column from "components/ui/layout/column/column";
import Row from "components/ui/layout/row/row";
import ActionButton from "components/ui/controls/action-button/ActionButton";
import TextField from "components/ui/controls/text-field/text-field";
import { FaCalculator } from "react-icons/fa";
const RevenusRetraite = () => {
  const context = useContext(AppContext);

  return (
    <>
      <Column fill>
        <CardBox bpad>
          <Column fill>
            <Row>
              {context.state.IdPeriodeRetraite !== "CarriereActuelle" && (
                <Column style={{ alignSelf: "flex-end" }}>
                  <ActionButton
                    onClick={() => {
                      context.handleRevenusAuPASS();
                    }}
                    icon={FaCalculator}
                    title="Forcer les revenus au PASS"
                    subtitle="Calcul automatique"
                    colors={{
                      primary: "#10b981",
                      secondary: "#059669",
                      shadow: "rgba(16, 185, 129, 0.4)",
                      shadowHover: "rgba(16, 185, 129, 0.6)",
                    }}
                    decorativeIcon={{ type: "pass" }}
                  />
                </Column>
              )}
              <Column hpad>
                <TextField
                  label="Taux d'indexation"
                  value={context.state.MontantEvolution}
                  onChange={context.handleCalculEvolutionRetraite}
                  dataType="float"
                  format={{ thousands: " ", unit: "%", decimal: ",", precision: 2 }}
                />
              </Column>
            </Row>
            <Row tpad>
              <Column fill>
                {/* Column headers for the list */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    width: "100%",
                    maxWidth: 700,
                    margin: "8px 0 8px 0",
                    paddingLeft: 12,
                    fontFamily: "Inter, -apple-system, BlinkMacSystemFont, sans-serif",
                    fontSize: 13,
                    color: "#64748b",
                    fontWeight: 600,
                    letterSpacing: "-0.01em",
                  }}
                >
                  <span style={{ minWidth: 96, marginRight: 18, textAlign: "center",fontSize:"12px" }}>Année</span>
                  <span style={{ width: 248, marginRight: 18, textAlign: "center",fontSize:"12px", display: "inline-block" }}>
                    {context.state.RetraiteActivite === "MicroRSI" ||
                    context.state.RetraiteActivite === "MicroBIC" ||
                    context.state.RetraiteActivite === "MicroBNC" ||
                    context.state.RetraiteActivite === "MicroCipav"
                      ? "Chiffre d'affaires"
                      : "Revenus soumis à cotisations sociales"}
                  </span>
                  {context.state.DisplayTrimestre === true && <span style={{ width: 200, textAlign: "center", paddingLeft: "12px",fontSize:"12px", display: "inline-block" }}>Trimestres</span>}
                  {context.state.DisplayDeplafondPass === true && <span style={{ width: 80, marginRight: 18, textAlign: "center",fontSize:"12px", display: "inline-block" }}>Déplaf. PASS</span>}
                  <span style={{ flex: 1 }}></span>
                </div>
                <ul
                  style={{
                    listStyle: "none",
                    padding: 0,
                    margin: 0,
                    width: "100%",
                    maxWidth: 700,
                    marginLeft: 0,
                    marginRight: 0,
                    display: "block",
                  }}
                >
                  {Object.keys(context.state.DetailRetraitePasse).map((Annee, index) => {
                    return (
                      <RevenusRetraiteCell
                        key={index.toString()}
                        id={index}
                        Annee={Annee}
                        DetailRetraiteConcerne={"DetailRetraitePasse"}
                        CalculTrimestre={context.handleCalculTrimestrePasse}
                        onCheck={context.handleCheckboxDetailRetraite}
                        onModifyRevenus={context.handleRevenusRetraitePasse}
                        onModifyTrimestre={context.handleSaisieTrimestre}
                        Revenus={context.state.DetailRetraitePasse[Annee]["Salaire"]}
                        Trimestre={context.state.DetailRetraitePasse[Annee]["Trimestre"]}
                        CheckboxTrimestre={context.state.DetailRetraitePasse[Annee]["CheckboxTrimestre"]}
                        CheckboxDeplafondPass={context.state.DetailRetraitePasse[Annee]["CheckboxDeplafondPass"]}
                        DisplayDeplafondPass={context.state.DisplayDeplafondPass}
                        DisplayTrimestre={context.state.DisplayTrimestre}
                      />
                    );
                  })}
                  {Object.keys(context.state.DetailRetraiteFutur).map((Annee, index) => {
                    return (
                      <RevenusRetraiteCell
                        key={index.toString()}
                        id={index}
                        Annee={Annee}
                        DetailRetraiteConcerne={"DetailRetraiteFutur"}
                        CalculTrimestre={context.handleCalculTrimestreFutur}
                        onCheck={context.handleCheckboxDetailRetraite}
                        onModifyRevenus={context.handleRevenusRetraiteFutur}
                        onModifyTrimestre={context.handleSaisieTrimestre}
                        Revenus={context.state.DetailRetraiteFutur[Annee]["Salaire"]}
                        Trimestre={context.state.DetailRetraiteFutur[Annee]["Trimestre"]}
                        CheckboxTrimestre={context.state.DetailRetraiteFutur[Annee]["CheckboxTrimestre"]}
                        DisplayTrimestre={context.state.DisplayTrimestre}
                        DisplayDeplafondPass={context.state.DisplayDeplafondPass}
                      />
                    );
                  })}
                </ul>
              </Column>
            </Row>
          </Column>
        </CardBox>
      </Column>
    </>
  );
};

export default RevenusRetraite;
